/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label, Modal } from "reactstrap";
import { HexColorPicker, HexAlphaColorPicker } from "react-colorful";

const ModalColorPicker = ({isOpen, toggle, alpha = false, color, onChange}) => {
  // handlers
  const handleColorChange = (color) => {
    // convert to upper case
    let outColor = color.toUpperCase();

    // add trailing "FF" to fully opaque alpha colors
    if (alpha && outColor.length === 7) {
      outColor += "FF";
    }
    onChange(outColor);
  };

  // helpers
  const Picker = alpha ? HexAlphaColorPicker : HexColorPicker;

  return (
    <Modal centered isOpen={isOpen} toggle={toggle}>
      <div className="layer-container">
        <Picker
          className="background-layer"
          color={color}
          onChange={handleColorChange}
          style={{ width: "100%", height: "360px" }}
        />
        <div className="d-flex justify-content-center align-items-end foreground-layer no-click">
          <Label className={`pb-${alpha ? "5" : "4"} fw-bold`} tag="h2" style={{ color: "#FFFFFF" }}>
            {color.toUpperCase()}
          </Label>
        </div>
      </div>
    </Modal>
  );
};

export default ModalColorPicker;
